import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Animated } from 'react-animated-css';

import StationSelector from '../../components/dashboard/StationSelector';
import SummaryCards from '../../components/dashboard/SummaryCards';
import StationsTable from '../../components/sites/SitesTable';

import './Sites.css';
import { initializeStation } from '../../utils/initStation';
import {
  getUserStationList,
  inspectionTimeUpdate
} from '../../modules/analytics';

class Sites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await initializeStation(this.props);
    this.setState({ loading: false });
  }



  render() {
    const { inspectionTime } = this.props;

    return (
      <Animated animationIn="fadeIn">
        <div className="sitesWrapper" style={{ paddingBottom: this.props.play ? '100px' : '20px' }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={17} className="leftPanel">
              <StationSelector pageTitle="Sites" />
              <SummaryCards stationId={inspectionTime.stationId} />
            </Col>
        </Row>
        <StationsTable stations={this.props.userStationList} />
      </div>
    </Animated>
  );
  }
}

const mapStateToProps = (state) => ({
  router: state.router,
  userProfile: state.user.userProfile,
  userStationList: state.analytics.userStationList,
  inspectionTime: state.analytics.inspectionTime,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserStationList,
      inspectionTimeUpdate,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Sites);
